import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const [showPhone, setShowPhone] = useState(false);
  const [showWechat, setShowWechat] = useState(false);
  const phonePopupRef = useRef(null);
  const wechatPopupRef = useRef(null);
  const navigate = useNavigate();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const togglePhone = () => {
    setShowPhone(!showPhone);
    setShowWechat(false); // 关闭微信弹窗
  };

  const toggleWechat = () => {
    setShowWechat(!showWechat);
    setShowPhone(false); // 关闭电话弹窗
  };

  const goToHome = () => {
    navigate('/');
  };

  // 添加点击外部关闭功能
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (phonePopupRef.current && !phonePopupRef.current.contains(event.target) &&
          !event.target.closest('.phone-btn')) {
        setShowPhone(false);
      }
      if (wechatPopupRef.current && !wechatPopupRef.current.contains(event.target) &&
          !event.target.closest('.wechat-btn')) {
        setShowWechat(false);
      }
    };

    if (showPhone || showWechat) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showPhone, showWechat]);

  return (
    <footer className="footer">
      {/* <div className="footer-content">
        <div className="contact-info">
          <div className="hotline">
            <h3>联系我们</h3>
            <p>24小时全国服务热线</p>
            <p className="phone">025-86215997</p>
          </div>
          <div className="social-media">
            <h3>联系我们</h3>
            <div className="social-icons">
              <img src="/images/allen.jpg" alt="屠先生" />
            </div>
          </div>
        </div>
      </div> */}
      {/* <div className="copyright">
        <p>Copyright © 2023南京南京棱讯有限公司 苏ICP备05079548号-1</p>
      </div> */}
      <div className="back-to-top" onClick={scrollToTop}>
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
          <path d="M12 19V5M5 12l7-7 7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>

      <div className="home-btn" onClick={goToHome}>
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
          <polyline points="9 22 9 12 15 12 15 22"></polyline>
        </svg>
      </div>

      <div className="phone-btn" onClick={togglePhone}>
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
        </svg>
      </div>

      <div className="wechat-btn" onClick={toggleWechat}>
        <img src="/images/wechat.svg" alt="微信" />
      </div>

      {showPhone && (
        <div className="phone-popup">
          <div className="phone-popup-content" ref={phonePopupRef}>
            <span className="phone-number no-call-phone">屠先生 18761618734</span>
            <a href="tel:+8618761618734" className="phone-number call-phone">屠先生 18761618734</a>
          </div>
        </div>
      )}

      {showWechat && (
        <div className="wechat-popup">
          <div className="wechat-popup-content" ref={wechatPopupRef}>
            <img src="/images/allen.jpg" alt="微信二维码" className="wechat-qrcode" />
            <span className="wechat-text">扫码添加微信</span>
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;